import { Divider, Grid, TextField } from "@mui/material";
import { FC } from "react";

export interface IMemoFormProps {
    hideQuoteMemo?: boolean;
    hideLineItemMemo?: boolean;
    hideDispatchBillingMemo?: boolean;
    hideOrderLineItemDriverMemo?: boolean;
    hideDriverComment?: boolean;
    quoteMemo?: string;
    lineItemMemo?: string;
    dispatchBillingMemo?: string;
    orderLineItemDriverMemo?: string;
    driverComment?: string;
    handleQuoteMemoChange?: (value: string) => void;
    handleLineItemMemoChange?: (value: string) => void;
    handleDispatchBillingMemoChange?: (value: string) => void;
    handleOrderLineItemDriverMemoChange?: (value: string) => void;
    handleDriverCommentChange?: (value: string) => void;
    disabled?: boolean;
    isOrderFormAndInReview?: boolean;
    orderReviewDispatchBillingMemo?: string;
};

export const MemoForm: FC<IMemoFormProps> = props => {
    const {
        hideQuoteMemo = false,
        hideLineItemMemo = false,
        hideDispatchBillingMemo = false,
        hideOrderLineItemDriverMemo = false,
        hideDriverComment = false,
        quoteMemo,
        lineItemMemo,
        dispatchBillingMemo,
        orderLineItemDriverMemo,
        driverComment,
        handleQuoteMemoChange,
        handleLineItemMemoChange,
        handleDispatchBillingMemoChange,
        handleOrderLineItemDriverMemoChange,
        handleDriverCommentChange,
        disabled,
        isOrderFormAndInReview,
        orderReviewDispatchBillingMemo
    } = props;

    return (
        <Grid item container direction='column' spacing={1}>
            {!hideQuoteMemo &&
                <>
                    <Grid item xs={12}>
                        <TextField
                            label='Quote Memo'
                            value={quoteMemo}
                            onChange={e => handleQuoteMemoChange && handleQuoteMemoChange(e.target.value)}
                            disabled={disabled || !handleQuoteMemoChange}
                            fullWidth
                            multiline
                            minRows={3}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </>
            }
            {!hideLineItemMemo &&
                <>
                    <Grid item xs={12}>
                        <TextField
                            label='Line Item Memo'
                            value={lineItemMemo}
                            onChange={e => handleLineItemMemoChange && handleLineItemMemoChange(e.target.value)}
                            disabled={disabled || !handleLineItemMemoChange}
                            fullWidth
                            multiline
                            minRows={3}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </>
            }
            {!hideDispatchBillingMemo && <Grid item xs={12}>
                <TextField
                    label={isOrderFormAndInReview ? 'Dispatch/Billing Memo (Original)' : 'Dispatch/Billing Memo'}
                    value={dispatchBillingMemo}
                    onChange={e => handleDispatchBillingMemoChange && handleDispatchBillingMemoChange(e.target.value)}
                    disabled={disabled || !handleDispatchBillingMemoChange}
                    fullWidth
                    multiline
                    minRows={3}
                />
            </Grid>}
            {!hideDispatchBillingMemo && isOrderFormAndInReview && < Grid item xs={12}>
                <TextField
                    label={'Dispatch/Billing Memo (From Order Review)'}
                    value={orderReviewDispatchBillingMemo}
                    disabled={true}
                    fullWidth
                    multiline
                    minRows={3}
                />
            </Grid>}
            {
                !hideOrderLineItemDriverMemo &&
                <>
                    <Grid item xs={12}>
                        <TextField
                            label='Order Memo'
                            value={orderLineItemDriverMemo}
                            onChange={e => handleOrderLineItemDriverMemoChange && handleOrderLineItemDriverMemoChange(e.target.value)}
                            disabled={disabled || !handleOrderLineItemDriverMemoChange}
                            fullWidth
                            multiline
                            minRows={3}
                        />
                    </Grid>
                </>
            }
            {
                !hideDriverComment && <>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label='Driver Comment'
                            value={driverComment}
                            onChange={e => handleDriverCommentChange && handleDriverCommentChange(e.target.value)}
                            disabled={disabled || !handleDriverCommentChange}
                            fullWidth
                            multiline
                            minRows={3}
                        />
                    </Grid>
                </>
            }
        </Grid >
    );
};